import React, { Component } from 'react';
import styles from './style.module.css';

// Long enough to read a sentence, short enough that it doesn't linger.
const AUTO_DISMISS_DELAY = 8000;

// Kept in step with the transition duration in style.module.css.
const FADE_OUT_DURATION = 300;

class Toast extends Component {
    constructor(props) {
        super(props);

        this.state = {
            height: null,
            leaving: false
        };

        this.node = React.createRef();
        this.timer = null;
        this.fadeTimer = null;
        this.frame = null;
        this.startDismiss = this.startDismiss.bind(this);
    }

    componentDidMount() {
        const {
            props: {
                duration = AUTO_DISMISS_DELAY
            }
        } = this;

        // `duration={false}` opts out of auto-dismissing.
        if (duration) {
            this.timer = setTimeout(this.startDismiss, duration);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
        clearTimeout(this.fadeTimer);
        cancelAnimationFrame(this.frame);
    }

    // Fades the toast out and collapses the space it occupied before handing
    // back to the parent, so the rest of the page doesn't jump the moment it
    // stops being rendered.
    startDismiss() {
        const {
            state: {
                leaving
            },
            props: {
                onDismiss
            }
        } = this;

        // Already on the way out (auto-dismiss racing a click, or a double click).
        if (leaving) {
            return;
        }

        clearTimeout(this.timer);

        // Pin the current height first — the collapse can only be animated from
        // a concrete value, never from `auto`.
        this.setState(
            {
                height: this.node.current ? this.node.current.offsetHeight : 0
            },
            () => {
                this.frame = requestAnimationFrame(() => {
                    this.setState({ leaving: true });

                    this.fadeTimer = setTimeout(() => {
                        if (onDismiss) {
                            onDismiss();
                        }
                    }, FADE_OUT_DURATION);
                });
            }
        );
    }

    render() {
        const {
            props: {
                message,
                dismissLabel = 'Dismiss this message'
            },
            state: {
                height,
                leaving
            }
        } = this;

        return (
            <div
                ref={this.node}
                className={leaving ? `${styles.toast} ${styles.leaving}` : styles.toast}
                style={height === null ? undefined : { height: leaving ? 0 : height }}
                role='alert'
            >
                <p className={styles.message}>{message}</p>
                <button
                    type='button'
                    className={styles.dismiss}
                    onClick={this.startDismiss}
                    title={dismissLabel}
                    aria-label={dismissLabel}
                >
                    &times;
                </button>
            </div>
        );
    }
}

export default Toast;
